import {
  IconButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  SvgIcon,
} from '@mui/material';
import { FC, SyntheticEvent, useCallback, useState } from 'react';
import { MdAccessTimeFilled, MdMoreVert as MoreVert } from 'react-icons/md';
import { ReactComponent as ExclusionsIcon } from '../../../assets/icons/exclusions.svg';

import OxMenuControlled from '../../../elements/OxMenu/OxMenuControlled';
import {
  setIssueDrawerPipeline,
  setMenuIssueIdPipeline,
} from '../actions/pipeline-issues-actions';
import { Exclusions, Issue } from '../../common/types/issues-types';
import { FiFlag } from 'react-icons/fi';
import {
  setExcludeIssueModal,
  setIsExcludeDedault,
} from '../../common/store-actions/issues-exclusions-store-actions';

const PipelineIssuesOptions: FC<React.PropsWithChildren<IssueOptionsProps>> = ({
  withOptions,
  issueId,
  isExcluded,
}) => {
  const [open, setOpen] = useState(false);

  const handleOpenMenu = useCallback(async (e: SyntheticEvent) => {
    e.stopPropagation();
    setOpen(true);
  }, []);

  const handleCloseMenu = useCallback(() => {
    setMenuIssueIdPipeline(null);
    setOpen(false);
  }, []);

  const excludeIssue = useCallback(async () => {
    await setIssueDrawerPipeline(issueId);
    setIsExcludeDedault(true);
    setExcludeIssueModal(true);
  }, [issueId]);

  return (
    <>
      <OxMenuControlled
        onClose={handleCloseMenu}
        open={open}
        trigger={
          <IconButton onClick={handleOpenMenu} size='small'>
            <MoreVert />
          </IconButton>
        }>
        <div>
          <MenuItem onClick={excludeIssue} disabled={isExcluded}>
            <ListItemIcon>
              <SvgIcon fontSize='inherit'>
                <ExclusionsIcon />
              </SvgIcon>
            </ListItemIcon>
            <ListItemText>Exclude Issue</ListItemText>
          </MenuItem>
          <MenuItem onClick={excludeIssue} disabled={isExcluded}>
            <ListItemIcon>
              <MdAccessTimeFilled />
            </ListItemIcon>
            <ListItemText>Snooze Issue</ListItemText>
          </MenuItem>
          <MenuItem>
            <ListItemIcon>
              <FiFlag />
            </ListItemIcon>
            <ListItemText>Report as FP</ListItemText>
          </MenuItem>
        </div>
      </OxMenuControlled>
    </>
  );
};

export interface IssueOptionsProps {
  policyDisableModal?: boolean;
  withOptions?: boolean;
  exclusionsCategories?: Exclusions[];
  handleExcludeAlert?: () => void;
  isActiveJiraConnection?: boolean;
  isPRAvailable: boolean;
  issueId: Issue['id'];
  fixIssue: Issue['fixIssue'];
  isExcluded?: boolean;
}

export default PipelineIssuesOptions;
